module.exports = __webpack_public_path__ + "static/img/VIKING_WHITE_LOGO.667978a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VIKING_WHITE_LOGO.png
// module id = x98x
// module chunks = 0